import type {NativeId} from '@packages/systems/core/utils/NativeIdUtils';

const sanitizeNativeId = (nativeId: NativeId): string =>
  nativeId.replace(/[^A-Za-z0-9_-]/g, '-');

export const getOverlayDomId = (
  prefix: string,
  runtimeNativeIdPath: readonly NativeId[]
): string => `${prefix}${runtimeNativeIdPath.map(sanitizeNativeId).join('__')}`;
